<template>
    <div class="signup-type border-bottom-light row justify-content-sm-center">
        <div class="col-sm-6" v-if="types">
            <label class="full">I am...</label>
            <v-select 
                @input="updateType" 
                v-model="type" 
                :options="types"
                label="description">
            </v-select>
        </div>
    </div>
</template>

<script>
    import extendedVSelect from '@/extends/vue-select'

    export default {
        props: {
            chosenType: String,
        },
        data: function() {
            return {
                type: null,
            }
        },
        asyncComputed: {
            async types() {
                try {
                    let response = await axios.get('/api/settings/GetAccountTypeList');

                    if (response && response.status === 200 && response.data && response.data.length > 0) {
                        this.type = response.data.find(t => t.description.toLowerCase() === this.chosenType);
                        this.updateType();
                        return response.data;
                    }
                }
                catch (error) {
                    this.$toasted.error(error.response.data.message);
                }
            }
        },
        methods: {
            updateType: function() {
                this.$emit('typeChanged', this.type);
            }
        },
        components: {
            vSelect: extendedVSelect,
        }
    }
</script>

<style lang="scss" scoped>
    .signup-type { 
        margin-top: 2rem;
        margin-bottom: 3rem;
        padding-top: 2rem;
        padding-bottom: 3rem;
    }
</style>



// WEBPACK FOOTER //
// SignupType.vue?dc513f3e